import { postRequest, getRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const getMaterialList = async (payload) => {
  try {
    return await postRequest(urls.GET_MATERIAL_LIST, payload);
  } catch (err) {
    return err;
  }
};

export const getMaterialDetails = async (payload) => {
  try {
    return await getRequest(`${urls.GET_MATERIAL_DETAILS}/${payload.materialId}`);
  } catch (err) {
    return err;
  }
};